import { Services } from '../services'

export type IiStatus = 'Draft' | 'Submitted'
export type IiIncidentType = 'Near Miss' | 'Injury' | 'Accident' | 'Other' | ''

function newGuid(): string {
    return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
              const r = (Math.random() * 16) | 0
              const v = c === 'x' ? r : (r & 0x3) | 0x8
              return v.toString(16)
          })
}

export class IiEmployee {
    id = ''
    sortOrder = 0
    userId: string | null = null
}

export class IiWitness {
    id = ''
    sortOrder = 0
    contactInformation = ''
    statement = ''
    signature = ''
}

export class IncidentInvestigation {
    id = ''
    indexId = 0
    incidentOn: Date = new Date()
    location = ''
    reportingPartyUserId: string | null = null
    jobNumber: string | null = null
    supervisorUserId: string | null = null
    equipmentOrVehicleNumber = ''
    thirdPartyInfo = ''
    whatHappened = ''
    causeOfIncident = ''
    policeOnScene = false
    caseNumber = ''
    fireOnScene = false
    emsOnScene = false
    witnessesPresent = false
    resultCausedInjury = false
    injuryDescription = ''
    incidentType: IiIncidentType = ''
    rootCause = ''
    correctiveAction = ''
    primaryCause = ''
    disciplinaryActionsGiven = false
    safetyDeptSignature = ''
    status: IiStatus = 'Draft'
    submittedOn: Date | null = null
    createdOn: Date = new Date()
    createdByUserId: string | null = null
    archived = false

    employees: IiEmployee[] = []
    witnesses: IiWitness[] = []
    imageUrls: string[] = []
    imageFileNames: string[] = []

    // Display fields populated by list/API (not sent back on save).
    reportingPartyName = ''
    supervisorName = ''
    involvedEmployeeNames = ''
    jobDisplay = ''

    static createNew(): IncidentInvestigation {
        const record = new IncidentInvestigation()
        record.id = newGuid()
        return record
    }

    protected $setProperties(source: any, _services: Services): void {
        source.reportingPartyName = source.reportingPartyName ?? ''
        source.supervisorName = source.supervisorName ?? ''
        source.involvedEmployeeNames = source.involvedEmployeeNames ?? ''
        source.jobDisplay = source.jobDisplay ?? source.jobNumber ?? ''
    }
}
